import { yup } from '@guiker/yup-util'

export const authenticateWithInvitationToken = yup
  .object({
    token: yup.string().required(),
  })
  .required()
